import {Injectable} from '@angular/core';
import {MediaMatcher} from '@angular/cdk/layout';

/**
 * Lets Angular Material animate even when the operating system asks for
 * reduced motion.
 *
 * Material decides once, through MediaMatcher, whether `(prefers-reduced-motion)`
 * matches, and if it does switches every component to its no-animation mode:
 * dialogs, menus, selects and snackbars then appear and vanish in a single
 * frame -- the closing half could not be put back from CSS at all, because the
 * element is removed at once. On Windows with "Animation effects" off, the
 * default on many machines, the whole app felt abrupt.
 *
 * The app answers reduced motion itself instead (src/styles/_motion.scss):
 * short fades stay, zoom and travel go. So Material is told motion is fine,
 * and every other media query goes through unchanged.
 */
@Injectable()
export class AppMediaMatcher extends MediaMatcher {
  override matchMedia(query: string): MediaQueryList {
    if (query.replace(/\s+/g, '') === '(prefers-reduced-motion)') {
      return {
        matches: false,
        media: query,
        onchange: null,
        addListener: () => undefined,
        removeListener: () => undefined,
        addEventListener: () => undefined,
        removeEventListener: () => undefined,
        dispatchEvent: () => false,
      } as MediaQueryList;
    }
    return super.matchMedia(query);
  }
}
